import { FormCheckboxGroupField, LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { AgeingTypes } from '@mews-commander/data-access';

const options: Record<AgeingTypes, React.ReactNode> = {
    LessThan30: <LocalizedText textKey={TextKey.CityLedgerFiltersAgeing} substitutes={{ count: '0-30' }} />,
    UpTo60: <LocalizedText textKey={TextKey.CityLedgerFiltersAgeing} substitutes={{ count: '31-60' }} />,
    UpTo90: <LocalizedText textKey={TextKey.CityLedgerFiltersAgeing} substitutes={{ count: '61-90' }} />,
    Plus90: <LocalizedText textKey={TextKey.CityLedgerFiltersAgeing} substitutes={{ count: '90+' }} />,
};

export const AgeingFilter = ({ name }: { name: string }) => {
    const ageingOptions = Object.entries(options).map(([key, value]) => ({
        label: value,
        value: key,
        name: key,
    }));

    return (
        <FormCheckboxGroupField
            data-test-id="ageing-filter"
            name={name}
            options={ageingOptions}
            label={<LocalizedText textKey={TextKey.Aging} />}
        />
    );
};
